export default __webpack_public_path__ + "d98c29af58b7b8436d0da9d3fc34efaa.svg";